import React from 'react'
import CreateHonoraryMemberForm from '../../features/HonoraryMemberForm/CreateHonoryMemberForm'

const CreateHonoryMember = () => {
  return (<CreateHonoraryMemberForm />)
}

export default CreateHonoryMember
